/* eslint-disable react/prop-types */
/* eslint-disable import/no-extraneous-dependencies */
import React, {
  useEffect,
  useState,
  // useMemo,
} from 'react';
import {
  MapContainer, TileLayer,
  //  Marker, Popup,
  // useMap,
} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { Select } from 'antd';
import { useHistory } from 'react-router-dom';
import { ControlButton } from './MapControls/ControlButton';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet.fullscreen/Control.FullScreen';
import 'leaflet.fullscreen/Control.FullScreen.css';
import '../../../../utils/leaflet-rotate/src/index';
import { TrackMouseMovement } from './MapControls/TrackMouseMovement';
import { useMapContext } from '../context/map-context';
import { MapLegend } from './MapControls/MapLegend';
import { MapEvents } from './MapControls/MapEvents';
import { FullscreenControl } from './MapControls/FullScreenControl';
import { FitBoundsToMarkers } from './MapControls/FitBoundsToMarkers';
import { RestoreSavedView } from './MapControls/RestoreSavedView';
import { ImageOverlay } from '../components/ImageOverlay';
import { useStore } from '../../../../store';
import { CustomPolygon } from './CustomPolygon';
import { LonLatAxes } from './MapControls/LonLatAxes';
import { XYAxes } from './MapControls/XYAxes';
import { CustomMarkers } from './CustomMarkers';
import { CustomAntennas } from './CustomAntennas';
import { TrailPolyline } from './TrailPolyline';
// import { CustomMarkersCanvasWithoutClusterization }
// from './CustomMarkersCanvasWithoutClusterization';
import { useActions } from '../../../providers/actions-provider/actions.context';
import { IAntenna } from './MapComponent.types';
import checkPermission from '../../../../utils/permissions';

const { Option } = Select;

export const MapComponent:React.FC = (
): JSX.Element | null => {
  const {
    onPinButtonClick, onMapButtonClick,
    onImageButtonClick, mapRef,
    onAntenaButtonClick,
    onZoneButtonClick,
    saveControlsStateHandler,
    configurationValues,
    onXYAxesButtonClick,
    updatePageSize,
    pageSizeOptions,
    onLLAxesButtonClick,
    imageAngle,
    savedViewState,
  } = useMapContext();
  const {
    mapOrigin,
    zonesForMaps,
    mapReport,
    mapImageImage,
    mapReportDefinition,
  } = useStore();

  const { location: { pathname } } = useHistory();
  const { reportActions } = useActions();
  const [antennas, setAntennas] = useState<IAntenna[]>();

  const DEFAULT_ZOOM = 18;
  const initialCenter: [number, number] = savedViewState?.pan ?? [
    Number(mapOrigin?.data?.latitude || 0),
    Number(mapOrigin?.data?.longitude || 0),
  ];
  const initialZoom = savedViewState?.zoom || DEFAULT_ZOOM;

  const tileUrl = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
  const hasNotWritePermission = !checkPermission('facilities', 'write');

  // we change style using css variables to avoid rerendering of the map
  useEffect(() => {
    document.documentElement.style.setProperty('--custom-pin-visibility', `${configurationValues?.visibility?.points ? 'visible' : 'hidden'}`);
    document.documentElement.style.setProperty('--custom-pin-opacity', `${(1 - configurationValues?.transparency?.points).toString()}`);

    document.documentElement.style.setProperty('--custom-cluster-visibility', `${configurationValues?.visibility?.points ? 'visible' : 'hidden'}`);
    document.documentElement.style.setProperty('--custom-cluster-opacity', `${(1 - configurationValues?.transparency?.points).toString()}`);

    document.documentElement.style.setProperty('--custom-antenna-visibility', `${configurationValues?.visibility?.antennas ? 'visible' : 'hidden'}`);
    document.documentElement.style.setProperty('--custom-antenna-opacity', `${(1 - configurationValues?.transparency?.points).toString()}`);
    document.documentElement.style.setProperty('--antenna-label-display', `${configurationValues?.visibility?.antennaLabels ? 'visible' : 'hidden'}`);

    document.documentElement.style.setProperty('--custom-zone-opacity', `${(1 - configurationValues?.transparency?.zones).toString()}`);
    document.documentElement.style.setProperty('--custom-zone-visibility', `${configurationValues?.visibility?.zones ? 'visible' : 'hidden'}`);
    document.documentElement.style.setProperty('--custom-zoneLabel-visibility', `${configurationValues?.visibility?.zoneLabels ? 'visible' : 'hidden'}`);

    // document.documentElement.style.setProperty('--canvas-visibility-handler',
    //  `${(configurationValues?.visibility?.points &&
    // !configurationValues?.visibility?.clusteredPins)
    //  ? 'visible' : 'hidden'}`);
  }, [configurationValues?.transparency?.points,
    configurationValues?.visibility?.antennaLabels,
    configurationValues?.visibility?.antennas,
    configurationValues?.transparency?.zones,
    configurationValues?.visibility?.zones,
    configurationValues?.visibility?.zoneLabels,
    configurationValues?.visibility?.points,
    // configurationValues?.visibility?.clusteredPins,
    imageAngle,
  ]);

  useEffect(() => {
    const fetchAntennas = async () => {
      const result = await reportActions.getTenantAntennasProperty(mapOrigin.data.group_code);
      setAntennas(result);
    };
    if (mapOrigin.data.group_code) {
      fetchAntennas();
    }
  }, [mapOrigin.data.group_code]);

  const reportCode = pathname.split('/')[4];
  if (mapOrigin.loading || mapReport.loading || mapImageImage.loading) return null;

  return (
    <div style={{ display: 'flex' }}>
      <MapContainer
        id="map"
        ref={mapRef}
        doubleClickZoom={false}
        center={initialCenter}
        zoom={initialZoom}
        style={{ height: 'calc(100vh - 100px)', width: '100%' }}
        rotate
        bearing={mapReportDefinition.data.config.orientation === 'yup' ? -Number(mapOrigin.data.azimuth || 0) : 0}
      >
        <RestoreSavedView />
        <FitBoundsToMarkers />
        <FullscreenControl />
        <TileLayer
          url={configurationValues?.visibility?.mapVisibilityControls ? tileUrl : ''}
          maxZoom={23}
          maxNativeZoom={19}
        />
        <div style={{
          height: '100vh',
          position: 'absolute',
          top: '0',
          right: '0',
          zIndex: 1000,
          backgroundColor: 'white',
        }}
        >
          <div style={{
            display: 'flex', flexDirection: 'column', gap: '8px', padding: '8px',
          }}
          >
            <ControlButton title="PIN" status={configurationValues?.visibility?.points} click={() => onPinButtonClick()} />
            <ControlButton title="MAP" status={configurationValues?.visibility?.mapVisibilityControls} click={() => onMapButtonClick()} />
            <ControlButton title="IMAGE" status={configurationValues?.visibility?.image} click={() => onImageButtonClick()} />
            <ControlButton title="ANTENNA" status={configurationValues?.visibility?.antennas} click={() => onAntenaButtonClick()} />
            <ControlButton title="ZONE" status={configurationValues?.visibility?.zones} click={() => onZoneButtonClick()} />
            <ControlButton title="LL AXES" status={configurationValues?.visibility?.llAxes} click={() => onLLAxesButtonClick()} />
            <ControlButton title="XY AXES" status={configurationValues?.visibility?.xyAxes} click={() => onXYAxesButtonClick()} />
            <ControlButton
              title="SAVE STATE"
              disabled={hasNotWritePermission}
              click={() => saveControlsStateHandler()}
            />
          </div>
        </div>
        <>
          <CustomMarkers />
          <CustomAntennas antennas={antennas} />
          <TrailPolyline />
          {/* <CustomMarkersCanvasWithoutClusterization /> */}
        </>
        { Object.entries(zonesForMaps.data.recordsMap).map(([title, zone]) => (
          zone.polygon ? (
            <CustomPolygon
              key={title}
              title={title}
              zoneCoords={JSON.parse(zone?.polygon)}
            />
          ) : null
        ))}
        <div style={{ zIndex: 1000 }}>

          <LonLatAxes />
          <XYAxes />
        </div>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          position: 'absolute',
          bottom: '0',
          zIndex: 1000,
          backgroundColor: 'white',
          width: '100%',
          height: '30px',
        }}
        >
          <TrackMouseMovement />
          <div>
            <span style={{ marginRight: '10px' }}>Page size</span>
            <Select
              defaultValue={configurationValues.pageSize}
              onChange={(size) => {
                updatePageSize(+size);
              }}
            >
              {
                pageSizeOptions.map((option, i) => (
                  <Option
                    value={option}
                    key={`${option + i}`}
                  >
                    {option}
                  </Option>
                ))
              }

            </Select>
          </div>
        </div>
        <MapLegend />
        <MapEvents />
        {configurationValues?.visibility?.image && reportCode === mapReport.data.code
         && <ImageOverlay />}
      </MapContainer>
    </div>
  );
};
